(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ganesha-intro-splash"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SESSION_KEY = 'ganesha-intro-splash-shown';

  function initSplash(splash) {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var alreadyShown = false;
    try {
      alreadyShown = sessionStorage.getItem(SESSION_KEY) === 'true';
    } catch (e) {
      alreadyShown = false;
    }
    if (alreadyShown) return;

    try {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } catch (e) {
      /* ignore */
    }

    splash.hidden = false;

    var closeTimer = null;
    var leaveTimer = null;

    function leave() {
      if (splash.classList.contains('is-leaving')) return;
      splash.classList.add('is-leaving');
      clearTimeout(closeTimer);
      window.setTimeout(function () {
        splash.hidden = true;
      }, 550);
    }

    requestAnimationFrame(function () {
      splash.classList.add('is-visible');
      window.setTimeout(function () {
        splash.classList.add('is-active');
      }, 150);
      window.setTimeout(function () {
        splash.classList.add('is-settled');
      }, 950);
    });

    splash.addEventListener('click', leave);

    closeTimer = window.setTimeout(leave, 3800);
  }

  var splashes = document.querySelectorAll('[data-ganesha-splash]');
  splashes.forEach(initSplash);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ganesha-sale-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGaneshaBar(bar) {
    var dismissKey = bar.getAttribute('data-dismiss-key');

    if (dismissKey && sessionStorage.getItem(dismissKey) === 'true') {
      bar.hidden = true;
      return;
    }

    var closeButton = bar.querySelector('[data-close-bar]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        bar.hidden = true;
        if (dismissKey) {
          sessionStorage.setItem(dismissKey, 'true');
        }
      });
    }
  }

  var bars = document.querySelectorAll('[data-ganesha-bar]');
  bars.forEach(initGaneshaBar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-increase-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPriceIncreaseBar(bar) {
    var dismissKey = bar.getAttribute('data-dismiss-key');

    if (dismissKey && sessionStorage.getItem(dismissKey) === 'true') {
      bar.hidden = true;
      return;
    }

    var closeButton = bar.querySelector('[data-close-bar]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        bar.hidden = true;
        if (dismissKey) {
          sessionStorage.setItem(dismissKey, 'true');
        }
      });
    }

    var countdown = bar.querySelector('[data-countdown]');
    if (!countdown) return;

    var IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

    function getIstNow() {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).formatToParts(new Date());

      var map = {};
      parts.forEach(function (part) {
        map[part.type] = part.value;
      });

      return {
        year: parseInt(map.year, 10),
        month: parseInt(map.month, 10),
        day: parseInt(map.day, 10),
        hour: parseInt(map.hour, 10) % 24
      };
    }

    function computeTarget() {
      var ist = getIstNow();
      var dayOffset = ist.hour < 17 ? 0 : 1;
      return Date.UTC(ist.year, ist.month - 1, ist.day + dayOffset, 23, 59, 59, 999) - IST_OFFSET_MS;
    }

    var target = computeTarget();

    var daysEl = countdown.querySelector('[data-days]');
    var hoursEl = countdown.querySelector('[data-hours]');
    var minutesEl = countdown.querySelector('[data-minutes]');
    var secondsEl = countdown.querySelector('[data-seconds]');

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function tick() {
      var now = Date.now();
      var diff = target - now;

      if (diff <= 0) {
        countdown.hidden = true;
        if (intervalId) clearInterval(intervalId);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
  }

  var bars = document.querySelectorAll('[data-price-increase-bar]');
  bars.forEach(initPriceIncreaseBar);
})();

  } catch(e) { console.error(e); }
})();
})();
